import { DefaultValue, RecoilState } from 'recoil';
import {
	ReadWriteSetOpts,
	ReadWriteSetNewValueNoDefault,
	ReadWriteSetReturn,
	ReadWriteSet
} from '../../types/ReadWriteSet';
import { isNotDefaultValue } from '../isNotDefaultValue';

export const setWrapper =
	<T, S>(
		stateToReset: RecoilState<S>,
		setFunction: (
			opts: ReadWriteSetOpts<T>,
			newValue: ReadWriteSetNewValueNoDefault<T>
		) => ReadWriteSetReturn<T>
	): ReadWriteSet<T> =>
	(opts, newValue) => {
		if (isNotDefaultValue(newValue)) {
			setFunction(opts, newValue);
		} else {
			opts.set(stateToReset, newValue as DefaultValue);
		}
	};
